import { fetchContacts, fetchContactsByOrganisation as fetchContactsByOrganisationApi, searchContacts as searchContactsApi, getContactById as getContactByIdApi, createContact, addContactAddress as addContactAddressApi, addContactEmail as addContactEmailApi, updateContactEmail as updateContactEmailApi, updateContactPhone as updateContactPhoneApi, deleteContactCommunicationChannel as deleteContactCommunicationChannelApi, addContactPhone as addContactPhoneApi, checkContactDuplicates as checkContactDuplicatesApi, getContactPreview as getContactPreviewApi, getContactSharedEmailGroup as getContactSharedEmailGroupApi, } from "../api/contactApi";
import { updateContactAddress as updateContactAddressApi, deleteContactAddress as deleteContactAddressApi, deleteContactOrgAddressLink as deleteContactOrgAddressLinkApi, } from "../api/contactAddressApi";
import { mapApiPaginated } from "@eudonet/opal";
import { mapApiContactToContact } from "../mappers/mapResponseToContact";
import { mapApiOrganisationContactToItem } from "../mappers/mapResponseToOrganisationContactItem";
import { mapApiContactByIdToContactDetail } from "../mappers/mapResponseToContactDetail";
import { searchWithFallback } from "@/shared/utils/paginatedSearch";
import { withSearchRefinement } from "@/shared/utils/quickFilters";
const CONTACT_SEARCH_FIELDS = ["firstName", "lastName"];
export async function searchContacts(params, signal) {
    const { search, ...query } = params;
    const filtered = Boolean(query.filterId || query.ast || query.refinement);
    // The POST search has no free-text field: with a filter active, the term travels as a refinement condition;
    // without one (e.g. the contact autocompletes), GET /contacts?search= matches it (case-insensitive substring on
    // first or last name).
    if (search && !filtered) {
        return mapApiPaginated(await fetchContacts({ search, page: params.page, perPage: params.pageSize, sortBy: params.sortBy, sortOrder: params.sortOrder }, signal), mapApiContactToContact);
    }
    const refinement = withSearchRefinement(query.refinement, search, CONTACT_SEARCH_FIELDS);
    return searchWithFallback(async () => mapApiPaginated(await searchContactsApi({ ...query, refinement }), mapApiContactToContact), async () => mapApiPaginated(await fetchContacts({ page: params.page, perPage: params.pageSize, sortBy: params.sortBy, sortOrder: params.sortOrder }), mapApiContactToContact), 
    // A filter is applied (saved view, inline AST or quick filters) — never degrade to the unfiltered list.
    { allowFallback: !filtered });
}
export async function getContactById(id) {
    return mapApiContactByIdToContactDetail(await getContactByIdApi(id));
}
export async function getContacts(options) {
    const apiResponse = await fetchContacts({
        page: options?.page,
        perPage: options?.pageSize,
        sortBy: options?.sortBy,
        sortOrder: options?.sortOrder,
        organisationId: options?.organisationId,
        search: options?.search,
    });
    return mapApiPaginated(apiResponse, mapApiContactToContact);
}
export async function searchContactsByOrganisation(organisationId, params) {
    const apiResponse = await fetchContactsByOrganisationApi({
        organisationId,
        page: params.page,
        perPage: params.pageSize,
        search: params.search,
        includeEnded: params.includeEnded,
    });
    return mapApiPaginated(apiResponse, mapApiOrganisationContactToItem);
}
export async function createNewContact(payload) {
    return createContact(payload);
}
export async function addContactAddress(contactId, payload) {
    return addContactAddressApi(contactId, payload);
}
export async function updateContactAddress(contactId, addressId, payload) {
    return updateContactAddressApi(contactId, addressId, payload);
}
export async function deleteContactAddress(contactId, addressId) {
    return deleteContactAddressApi(contactId, addressId);
}
export async function deleteContactOrgAddressLink(contactId, linkId, organisationId, addressId) {
    return deleteContactOrgAddressLinkApi(contactId, linkId, organisationId, addressId);
}
export async function addContactEmail(contactId, payload) {
    return addContactEmailApi(contactId, payload);
}
export async function addContactPhone(contactId, payload) {
    return addContactPhoneApi(contactId, payload);
}
export async function updateContactEmail(contactId, channelId, payload) {
    return updateContactEmailApi(contactId, channelId, payload);
}
export async function getContactSharedEmailGroup(contactId, channelId) {
    return getContactSharedEmailGroupApi(contactId, channelId);
}
export async function updateContactPhone(contactId, channelId, payload) {
    return updateContactPhoneApi(contactId, channelId, payload);
}
export async function deleteContactPhone(contactId, channelId) {
    return deleteContactCommunicationChannelApi(contactId, channelId);
}
export async function deleteContactEmail(contactId, channelId, newPrimaryChannelId) {
    return deleteContactCommunicationChannelApi(contactId, channelId, newPrimaryChannelId);
}
export async function checkContactDuplicates(params, signal) {
    return checkContactDuplicatesApi(params, signal);
}
export async function getContactPreview(id) {
    return getContactPreviewApi(id);
}
